import { gql } from "@apollo/client"; // saveVisitaParenteral.js


const SAVE_PROGRAMA_CEAO_NUTRICIONISTA = gql`
  mutation saveVisitaCeaoNutricionista($input: AddVisitaCeaoNutricionistaInput!) {
    saveVisitaCeaoNutricionista(input: $input) {
      idVisita
      idVisitaCeao
    }
  }
`;

export default SAVE_PROGRAMA_CEAO_NUTRICIONISTA;

export const adaptAddVisitaCEAONutricionistaInput = (data) => ({
  idVisitaCeao: data?.idVisitaCeao,
  justificacionModificacion: data?.justificacionModificacion,
  indicacionComentario: data?.indicacionComentario,
  caloriasTotales: data?.caloriasTotales,
  caloriasSO: data?.caloriasSO,
  porcentajeSO: data?.porcentajeSO,
  complicaciones: data?.complicaciones,
  listaIndicacion: data?.listaIndicacion?.map((item) => ({
    idInsumo: item?.idInsumo,
    cantidadDiaria: item?.cantidadDiaria
  })),
  idVisita: data?.idVisita
});